import { Injectable } from "@angular/core";
import { AnyAccountJwtVO, Conf2AccountJwtVO } from "@common/domain";
import { AccountFacade } from "@youm-front/account/data-access";
import { AccountJwtService } from "@youm-front/account-jwt/data-access";
import { map } from "rxjs/operators";

@Injectable()
export class IdentityAccountOnlyGuard {
  constructor(
    private readonly accountFacade: AccountFacade,
    private readonly accountJwtService: AccountJwtService
  ) {}

  canActivate() {
    return this.accountJwtService.anyAccountJwtVO$.pipe(
      map((_) => this.handler(_))
    );
  }

  private handler(accountJwt: null | AnyAccountJwtVO) {
    if (!accountJwt || accountJwt instanceof Conf2AccountJwtVO) {
      this.accountFacade.redirectToAuth();
      return false;
    }

    return true;
  }
}
